import loaded from '@/scripts/utils/loaded.js';

function each(nodes, fn) {
    Array.prototype.forEach.call(nodes, fn);
}

function setText(nodes, text) {
    each(nodes, (el) => { el.textContent = text; });
}

function money(cents) {
    const S = window.Shopify;
    if (S && typeof S.formatMoney === 'function') {
        return S.formatMoney(cents, (S.money_format || '${{amount}}').replace('amount', 'amount_no_decimals'));
    }
    return '$' + Math.round(cents / 100);
}

function init() {
    const bar = document.querySelector('[data-pdp-sticky-bar]');
    if (!bar) return;

    // Bundle PDPs use a 3rd-party widget instead of the standard form — skip.
    if (document.querySelector('.pdp-hero--bundle')) return;

    const form = document.querySelector('.pdp-form');
    const mainBtnWrap = document.querySelector('.pdp-hero .pdp-button');
    if (!form || !mainBtnWrap) return;

    // The PDP lives inside <main class="site-content"> which has `contain: paint` — that makes
    // it the containing block for any position:fixed child, so the bar would anchor to the page
    // bottom instead of the viewport. Move it to <body> to pin it correctly.
    document.body.appendChild(bar);

    const prices = bar.querySelectorAll('[data-sticky-price]');
    const compares = bar.querySelectorAll('[data-sticky-compare]');
    const states = bar.querySelectorAll('[data-sticky-state]');
    const adds = bar.querySelectorAll('[data-sticky-add]');
    const variantInputs = bar.querySelectorAll('[data-sticky-variant]');

    function soldOutLabel() {
        const label = adds[0] ? adds[0].getAttribute('data-sold-out-label') : null;
        return label || 'Sold Out';
    }

    // Reflect a variant the shared VariantPicker resolved. The `variant:change` event is the
    // single source of truth — the bar never reads the form's DOM.
    function reflect(variant) {
        if (!variant) {
            each(adds, (el) => el.classList.add('is-state', 'sold-out'));
            setText(states, 'Unavailable');
            return;
        }

        const buyable = !!variant.available;
        if (buyable) {
            each(adds, (el) => el.classList.remove('is-state', 'sold-out'));
        } else {
            each(adds, (el) => el.classList.add('is-state', 'sold-out'));
            setText(states, soldOutLabel());
        }

        setText(prices, money(variant.price));

        if (buyable && variant.compare_at_price > variant.price) {
            setText(compares, money(variant.compare_at_price));
            each(compares, (el) => el.classList.add('shown'));
        } else {
            setText(compares, '');
            each(compares, (el) => el.classList.remove('shown'));
        }

        if (variant.id && variantInputs.length) {
            each(variantInputs, (el) => { el.value = variant.id; });
        }
    }

    document.addEventListener('variant:change', (e) => {
        reflect(e.detail && e.detail.variant);
    });

    // pdp-form.js runs earlier in the document and has already emitted its initial
    // `variant:change`, so catch up from the picker. A null here means a single-variant
    // product (no option inputs) — the server-rendered bar is already correct then.
    const initialVariant = form.variantPicker && form.variantPicker.currentVariant;
    if (initialVariant) reflect(initialVariant);

    // Bar variant change asks the shared picker to select that variant, which runs all of the
    // variant logic (price, image, waitlist) and emits `variant:change` back to reflect() above.
    each(variantInputs, (el) => {
        el.addEventListener('change', function () {
            const id = this.value;

            // Selecting a waitlisted/sold-out variant makes waitlistForm insert its form *before*
            // .pdp-form — i.e. above the viewport, since the bar only appears once the form has
            // scrolled past. Re-anchor the scroll.
            const beforeY = window.pageYOffset;
            const beforeHeight = document.documentElement.scrollHeight;

            document.dispatchEvent(new CustomEvent('pdp:select-variant', {detail: {id}}));

            const delta = document.documentElement.scrollHeight - beforeHeight;
            if (delta) window.scrollTo(0, beforeY + delta);
        });
    });

    // The bar button just clicks the real submit button (reuses qty + variant).
    each(adds, (el) => {
        el.addEventListener('click', function () {
            if (this.classList.contains('sold-out')) {
                // Sold out → send the user to the form where the waitlist lives.
                const top = form.getBoundingClientRect().top + window.scrollY;
                window.scrollTo({top: top - 120, behavior: 'smooth'});
                return;
            }
            const mainBtn = document.querySelector('.pdp-hero .pdp-button button');
            if (mainBtn) mainBtn.click();
        });
    });

    // The bar is shown when the real "Add to bag" button has scrolled ABOVE the viewport, and
    // hidden again once the footer scrolls into view so the fixed bar never overlaps it. Both
    // observers feed these flags and a single applyVisibility() resolves the final state.
    let buttonScrolledPast = false;
    let footerInView = false;

    function applyVisibility() {
        const show = buttonScrolledPast && !footerInView;
        bar.classList.toggle('pdp-sticky-bar--visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');

        // #back-top is pinned to the same corner with a lower z-index, so it would sit under
        // the bar. Publish the height and let it move up.
        document.documentElement.style.setProperty('--pdp-sticky-bar-h', show ? bar.offsetHeight + 'px' : '0px');
    }

    if (!('IntersectionObserver' in window)) return;

    // Show once the main button has disappeared upward — not while it's still below the fold
    // and the user hasn't reached it yet (the button sits below the title/description/image on
    // mobile).
    new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            const viewportTop = entry.rootBounds ? entry.rootBounds.top : 0;
            const scrolledPast = entry.boundingClientRect.bottom <= viewportTop;
            buttonScrolledPast = !entry.isIntersecting && scrolledPast;
            applyVisibility();
        });
    }, {threshold: 0}).observe(mainBtnWrap);

    // Hide the bar while the footer is on screen so it never overlaps it.
    const footer = document.querySelector('footer.footer');
    if (footer) {
        new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                footerInView = entry.isIntersecting;
                applyVisibility();
            });
        }, {threshold: 0}).observe(footer);
    }
}

loaded(init);
